export class ZeroEtlTargetTablesFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ids",
            "baseName": "ids",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "icebergFullName",
            "baseName": "icebergFullName",
            "type": "string",
            "format": ""
        },
        {
            "name": "icebergNamespace",
            "baseName": "icebergNamespace",
            "type": "string",
            "format": ""
        },
        {
            "name": "icebergTable",
            "baseName": "icebergTable",
            "type": "string",
            "format": ""
        },
        {
            "name": "statuses",
            "baseName": "statuses",
            "type": "Array<ZeroEtlTargetTableStatus>",
            "format": ""
        },
        {
            "name": "policyIds",
            "baseName": "policyIds",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "resourceNames",
            "baseName": "resourceNames",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceTypes",
            "baseName": "resourceTypes",
            "type": "Array<ResourceType>",
            "format": ""
        },
        {
            "name": "cloudProviders",
            "baseName": "cloudProviders",
            "type": "Array<Provider>",
            "format": ""
        },
        {
            "name": "sourceAccountName",
            "baseName": "sourceAccountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountIds",
            "baseName": "sourceAccountIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "sourceRegions",
            "baseName": "sourceRegions",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "vaultIds",
            "baseName": "vaultIds",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "lastFullSyncAfter",
            "baseName": "lastFullSyncAfter",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lastFullSyncBefore",
            "baseName": "lastFullSyncBefore",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAfter",
            "baseName": "updatedAfter",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedBefore",
            "baseName": "updatedBefore",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return ZeroEtlTargetTablesFilters.attributeTypeMap;
    }
    constructor() {
    }
}
